import { render, staticRenderFns } from "./CoachesAndTribeInfo.vue?vue&type=template&id=6e60b4c4"
import script from "./CoachesAndTribeInfo.vue?vue&type=script&lang=ts"
export * from "./CoachesAndTribeInfo.vue?vue&type=script&lang=ts"
import style0 from "./CoachesAndTribeInfo.vue?vue&type=style&index=0&id=6e60b4c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports